import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/24/outline';
import styles from './AdminClient.module.css';
import {adminClientListAPI} from "../../../../services/admin";
import AdminClientInfo from "./AdminClientInfo";

interface AdminClientProps {
    clientId: number;
}

//클라이언트 상세 페이지 버튼
const AdminClient: React.FC<AdminClientProps> = ({clientId}) => {
    const navigate = useNavigate();
    const [clientIds, setClientIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                //클라이언트 식별자 목록 API
                const response = await adminClientListAPI();
                setClientIds(response);
                const index = response.findIndex(cid => cid === clientId);
                setCurrentIndex(index);
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchClients();
    }, [clientId]);

    //이전 클라이언트 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevClientId = clientIds[currentIndex - 1];
            navigate(`/admin/clients/account/${prevClientId}`);
        }
    };

    //다음 클라이언트 페이지
    const handleNext = () => {
        if (currentIndex < clientIds.length - 1) {
            const nextClientId = clientIds[currentIndex + 1];
            navigate(`/admin/clients/account/${nextClientId}`);
        }
    };

    //클라이언트 식별자가 없을 경우
    if (!clientId) {
        return <div>Invalid project ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*이전 클라이언트 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous client"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    {/*클라이언트 정보*/}
                    <AdminClientInfo clientId={clientId}/>
                </div>

                {/*다음 클라이언트 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === clientIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === clientIds.length - 1}
                    aria-label="Next client"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    );
};

export default AdminClient;